import {
  getBulkModifiersDetails,
  handlePointModifers,
  postBulkPointModifiersDraft,
  putBulkPointModifiersDraft,
} from '@/services/bulkModifiers'
import {useAppDispatch, useAppSelector} from '@/store'
import {useDropdown} from '@/hooks/Dropdown-hook'
import {DROPDOWN_TYPES} from '@/utils/constants/dropdownConstants'
import {resetBulkModifiers, setBulkModifiers} from '@/store/slices/bulkPointSlice'
import {setToastNotifications} from '@/store/slices/commonSlice'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useCallback, useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {getFormattedDateString, getUUID} from '@/utils/commons'
export default function useReviewBulkPointModifier() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const bulkModifier = useAppSelector(state => state?.bulkModifiers)
  const {dropdownList: dropdownListActions} = useDropdown({dropdownType: DROPDOWN_TYPES.Actions})

  const {state = {}} = useLocation()
  const {id, uuid} = state || {}
  const [loading, setLoading] = useState(false);
  const handleCancel = () => {
    dispatch(resetBulkModifiers())
    navigate(ROUTES.BULK_POINT_MODIFIERS)
  }

  const getActionsValue = actions => {
    if (actions && dropdownListActions) {
      return dropdownListActions?.find(item => item.displayText === actions)?.value
    }
    return null
  }

  const getBulkModifierParams = () => {
    return {
      storeSelectorName: bulkModifier?.storeSelector,
      name: bulkModifier?.bulkModifierName || bulkModifier?.name,
      noOfDays: bulkModifier?.numberOfDays,
      noOfPoints: bulkModifier?.numberOfPoints,
      schedule: bulkModifier?.schedule,
      startDate: bulkModifier?.startDate && getFormattedDateString(bulkModifier.startDate),
      file: bulkModifier?.storeList,
      endDate: bulkModifier?.endDate && getFormattedDateString(bulkModifier.endDate),
      action: getActionsValue(bulkModifier?.actions),
    }
  }

  const handlePublish = async () => {
    const param = getBulkModifierParams()
    try {
      let response = await handlePointModifers({data: param})
      if (response?.success) {
        dispatch(setBulkModifiers(bulkModifier))
        dispatch(setToastNotifications({show: true, message: 'New Bulk point modifier published', type: 'success'}))
        dispatch(resetBulkModifiers())
        navigate(ROUTES.BULK_POINT_MODIFIERS)
      } else {
        const errMsg = response?.errorMessage || 'An unknown error occurred'
        dispatch(setToastNotifications({show: true, message: errMsg, type: 'error'}))
      }
    } catch (error) {
      const errMsg = error?.response?.data?.errorMessage || error?.message || 'An unknown error occurred'
      dispatch(setToastNotifications({show: true, message: errMsg, type: 'error'}))
    }
  }

  const handleDraft = async () => {
    const isNameChanged = bulkModifier?.bulkModifierName !== bulkModifier?.name
    const isDraft = !!bulkModifier?.uuid
    const param = {
      ...getBulkModifierParams(),
      endDate: bulkModifier?.endDate && getFormattedDateString(bulkModifier.endDate),
      status: 'DRAFT',
      uuid: isNameChanged ? getUUID(bulkModifier?.bulkModifierName) : getUUID(bulkModifier?.name),
    }
    const callPutApi = isDraft && !isNameChanged
    let response =
      callPutApi
        ? await putBulkPointModifiersDraft({data: param})
        : await postBulkPointModifiersDraft({data: param})
    if (response?.success) {
      dispatch(setToastNotifications({show: true, message: callPutApi ? 'Bulk point modifier updated' : 'New Bulk point modifier saved', type: 'success'}))
      dispatch(resetBulkModifiers())
      navigate(ROUTES.BULK_POINT_MODIFIERS)
    } else {
      dispatch(setToastNotifications({show: true, message: 'Failed to save draft', type: 'error'}))
    }
  }

  const handleGetBulkModifierDetails = useCallback(async () => {
    if (uuid) {
      return await getBulkModifiersDetails(uuid, 0, 10, 'uuid')
    } else {
      return await getBulkModifiersDetails(id, 0, 10, 'id')
    }
  }, [id, uuid])

  const getBulkModifierDetailsById = useCallback(async () => {
    try{
    setLoading(true)  
    const res = await handleGetBulkModifierDetails()
    setLoading(false)
    const result = res?.data[0]
    const updatedResponse = {
      actions: result?.action,
      startDate: result?.startDate,
      schedule: result?.schedule,
      storeSelector: result?.storeSelectorName,
      bulkModifierName: result?.bulkModifierName || result?.name,
      file: result?.file,
      endDate: result?.endDate,
      name: result?.name,
      numberOfPoints: result?.noOfPoints,
      numberOfDays: result?.noOfDays,
      uuid: result?.uuid || '',
    }
    dispatch(setBulkModifiers(updatedResponse))
  }catch{
    setLoading(false)
  }
  }, [handleGetBulkModifierDetails, dispatch])

  useEffect(() => {
    if (id || uuid) {
      getBulkModifierDetailsById()
    }
  }, [getBulkModifierDetailsById, id, uuid])

  return {
    handleCancel,
    handlePublish,
    handleDraft,
    id,loading
  }
}
